<template>
  <div>
    <vs-row>
      <vs-col
        v-if="team && team.main_photo && team.main_photo.public_id"
        vs-w="2"
        vs-sm="12"
      >
        <cld-image :public-id="team.main_photo.public_id">
          <cld-transformation width="150" crop="scale" />
        </cld-image>
      </vs-col>
      <template v-if="team && team.main_photo && team.main_photo.public_id">
        <vs-col vs-w="8">
          <vs-col vs-type="flex" vs-w="12">
            <h2 class="center">{{ teamName }}</h2>
          </vs-col>
        </vs-col>
      </template>
      <template v-else>
        <vs-col vs-type="flex" vs-w="12">
          <h2 class="center">
            {{ teamName }}
          </h2>
        </vs-col>
      </template>
    </vs-row>
    <vs-row>
      <vs-col vs-w="2" v-if="teamLeague && teamLeague.tip_teams">
        <vs-button type="border" @click="attemptTipTeam"
          >Tip the Team!</vs-button
        >
      </vs-col>
    </vs-row>
    <vs-divider />
    <vx-card>
      <vs-tabs>
        <vs-tab label="Results">
          <div class="tab-text">
            <vs-table :data="games" :noDataText="emptyGameTxt">
              <template slot="thead">
                <vs-th>Date</vs-th>
                <vs-th>Court</vs-th>
                <vs-th>League</vs-th>
                <vs-th>Opponent</vs-th>
                <vs-th>Score</vs-th>
                <vs-th>Result</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr v-for="tr in data" :key="tr.id">
                  <vs-td :data="tr.game_date">
                    {{ dateFormat(Date.parse(tr.game_date)) }}
                  </vs-td>
                  <vs-td :data="tr.court_name">
                    {{ tr.court_name }}
                  </vs-td>
                  <vs-td :data="tr.league_name">
                    <router-link
                      :to="{ name: 'league', params: { id: tr.league_id } }"
                    >
                      {{ tr.league_name }}
                    </router-link>
                  </vs-td>
                  <vs-td :data="opponent(tr)">
                    <router-link
                      :to="{ name: 'team', params: { id: opponentId(tr) } }"
                    >
                      {{ opponent(tr) }}
                    </router-link>
                  </vs-td>
                  <vs-td :data="score(tr)">
                    <router-link
                      :to="{ name: 'boxscore', params: { id: tr.game_id } }"
                    >
                      {{ score(tr) }}
                    </router-link>
                  </vs-td>
                  <vs-td :data="tr.home_team_score">
                    {{ winLoss(tr) }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
        <vs-tab label="Players">
          <div class="tab-text">
            <PlayerListing :team="team" @editPlayer="navigatePlayer" />
          </div>
        </vs-tab>
        <vs-tab label="Schedule">
          <div class="tab-text">
            <vs-table :data="schedule" noDataText="No Games Found">
              <template slot="thead">
                <vs-th>Date</vs-th>
                <vs-th>Court</vs-th>
                <vs-th>League</vs-th>
                <vs-th>Opponent</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="tr.id" v-for="tr in schedule">
                  <vs-td :data="tr.game_date">
                    {{ dateFormat(Date.parse(tr.game_date)) }}
                  </vs-td>
                  <vs-td :data="tr.court">
                    {{ tr.court }}
                  </vs-td>
                  <vs-td :data="tr.league">
                    {{ tr.league }}
                  </vs-td>
                  <vs-td :data="tr.opponent">
                    {{ tr.opponent }}
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vs-tab>
        <vs-tab label="Analytics">
          <div class="tab-text">
            <Analytics :id="id" :league="team.league_id" :embed="true" />
          </div>
        </vs-tab>
      </vs-tabs>
    </vx-card>
    <vs-popup :title="`Tip the ${teamName}!`" :active.sync="addTipTeam">
      <h3>Thank You</h3>
      <div>We appreciate your contribution to our team.</div>
      <div>You can leave us a message if you would like</div>
      <div>
        <vs-textarea
          name="description"
          v-model="tipTeamDescription"
          icon-no-border
          icon="icon icon-user"
          icon-pack="feather"
          label=""
          class="w-full h5"
        />
      </div>
      <div>
        <div>The minimum tip is 1 Ballstar credit.</div>
        <vs-input-number v-model="tipTeamAmount" min="1" />
      </div>
      <vs-divider />
      <div>
        You have <strong>{{ accountBalance }}</strong> Ballstar credits
        available.
      </div>
      <div v-if="accountBalance >= tipTeamAmount">
        You are about to tip <strong>{{ tipTeamAmount }}</strong> of your
        Ballstar credits.
      </div>
      <div v-else style="color:red">
        You dont have enough credits to tip
        <strong>{{ tipTeamAmount }}</strong
        >.
      </div>
      <div style="margin: 10px 0 0">
        <vs-button
          @click="tipTeam()"
          :disabled="accountBalance < tipTeamAmount"
        >
          Tip the Team!
        </vs-button>
      </div>
    </vs-popup>
    <vs-popup title="Login or Create an Account" :active.sync="loginCreateForm">
      <div>
        You must <a href="/login" target="_blank">Login</a> or
        <a href="/register" target="_blank">Create an account</a> to register a
        team in this league.
      </div>
    </vs-popup>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import PlayerListing from "./PlayerListing";
import UserRoles from "@/mixins/UserRoles";
import Analytics from "./Analytics";
const dateTimeFormat = new Intl.DateTimeFormat("en", {
  year: "numeric",
  month: "short",
  day: "2-digit",
  hour: "numeric",
  minute: "numeric"
});

export default {
  name: "Team",
  created() {
    this.loadTeamAndGames();
  },
  components: {
    PlayerListing,
    Analytics
  },
  mixins: [UserRoles],
  props: ["id"],
  watch: {
    id() {
      this.loadTeamAndGames();
    }
  },
  data() {
    return {
      games: [],
      schedule: [],
      team: {},
      emptyGameTxt: "",
      users: [],
      teamLeague: {},
      accountPayments: [],
      tipTeamAmount: 1,
      tipTeamDescription: "",
      addTipTeam: false,
      loginCreateForm: false
    };
  },
  computed: {
    teamName() {
      return this.team && this.team.name;
    },
    accountBalance() {
      return (
        this.accountPayments &&
        this.accountPayments.reduce((acc, obj) => {
          acc += obj.credits;
          return acc;
        }, 0)
      );
    }
  },
  methods: {
    ...mapActions({
      getTeam: "team/getTeam",
      getLeague: "league/getLeague",
      getTeamSchedule: "team/getTeamSchedule",
      myPayments: "payments/myPayments"
    }),
    dateFormat(d) {
      return dateTimeFormat.format(d);
    },
    async loadPayments() {
      try {
        const { json } = await this.myPayments();
        this.accountPayments = json;
      } catch (ex) {
        this.accountPayments = [];
      }
    },
    async loadLeague() {
      this.teamLeague = await this.getLeague({ id: this.team.league_id });
    },
    async loadTeam() {
      if (this.id) {
        this.team = await this.getTeam({ id: this.id });
        this.loadLeague();
        this.loadPayments();
        if (this.team) {
          this.team.season = [{ id: this.team.season_id }];
        }
      }
    },
    async loadTeamAndGames() {
      this.$vs.loading();
      await this.loadTeam();
      await this.loadTeamGames();
      this.$vs.loading.close();
    },
    async loadTeamGames() {
      this.emptyGameTxt = "Searching Ballstar database...";
      const { json } = await this.getTeamSchedule({
        teamId: this.team.season_id
      });
      if (!json.length) {
        this.emptyGameTxt = "No Games found";
        this.games = [];
      } else {
        this.games = json
          .filter(g => g.active)
          .sort((b, a) => new Date(a.game_date) - new Date(b.game_date));
      }
    },
    opponent(gameData) {
      if (gameData.awayteam_id === this.id) {
        return gameData.hometeam_name;
      } else if (gameData.hometeam_id === this.id) {
        return gameData.awayteam_name;
      }

      return "";
    },
    opponentId(gameData) {
      if (gameData.awayteam_id === this.id) {
        return gameData.hometeam_id;
      } else if (gameData.hometeam_id === this.id) {
        return gameData.awayteam_id;
      }

      return null;
    },
    winLoss(gameData) {
      if (gameData.awayteam_id === this.id) {
        if (gameData.away_team_score > gameData.home_team_score) {
          return "WIN";
        } else if (gameData.away_team_score < gameData.home_team_score) {
          return "LOSS";
        } else if (!gameData.home_team_score && !gameData.away_team_score) {
          return "";
        }

        return "TIE";
      } else if (gameData.hometeam_id === this.id) {
        if (gameData.home_team_score > gameData.away_team_score) {
          return "WIN";
        } else if (gameData.home_team_score < gameData.away_team_score) {
          return "LOSS";
        } else if (!gameData.home_team_score && !gameData.away_team_score) {
          return "";
        }
        return "TIE";
      }

      return "";
    },
    score(gameData) {
      return `${gameData.away_team_score || 0} - ${gameData.home_team_score ||
        0}`;
    },
    navigatePlayer(player) {
      this.$router.push({ name: "player", params: { id: player.id } });
    },
    attemptTipTeam() {
      if (this.user) {
        this.loadPayments();
        this.addTipTeam = true;
      } else {
        this.loginCreateForm = true;
      }
    }
  },
  metaInfo() {
    return { title: `${this.teamName} - Team` };
  }
};
</script>
